import { ShadowTestResultResponse } from "../lusca-search-api/generated-src";

export type ShadowTestResultStatus = "PASSED" | "FAILED" | "BLOCKED";
export type ShadowTestResultResponseWithCompat = ShadowTestResultResponse & {
  resultStatus?: ShadowTestResultStatus;
  resultStatusMessage?: string;
};

export const getShadowTestResultStatus = (
  result: Pick<ShadowTestResultResponseWithCompat, "passed" | "resultStatus">
): ShadowTestResultStatus => {
  if (result.resultStatus) return result.resultStatus;

  // TODO(TRACK-11109): Remove this compatibility fallback after all Cyberman
  // records and API responses contain resultStatus.
  return result.passed ? "PASSED" : "FAILED";
};

export const getShadowTestStatusIndicatorType = (
  status: ShadowTestResultStatus
): "success" | "error" | "warning" => {
  switch (status) {
    case "PASSED":
      return "success";
    case "BLOCKED":
      return "warning";
    case "FAILED":
      return "error";
  }
};

export const getShadowTestButtonIconName = (
  result:
    | Pick<ShadowTestResultResponseWithCompat, "passed" | "resultStatus">
    | null
    | undefined
): "status-positive" | "status-negative" | "status-warning" | "status-info" => {
  if (!result) return "status-info";
  switch (getShadowTestResultStatus(result)) {
    case "PASSED":
      return "status-positive";
    case "BLOCKED":
      return "status-warning";
    case "FAILED":
      return "status-negative";
  }
};
